import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Sidebar } from "./components/sidebar/Sidebar";
import { Toaster } from "./components/ui/toaster";

import LoginPage from "./components/login";
import UserList from "./components/users/users";
import UserShow from "./components/users/user.view";
// import UserEdit from "./components/users/user.edit";
import AssetList from "./components/nft/nfts";
import NFTCreate from "./components/nft/nft.create";
import NFTEdit from "./components/nft/nft.edit";
import NFTShow from "./components/nft/nft.view";
// import NFTEdit from "./components/nft/nft.edit";
import RentalList from "./components/nft/rental";
import RentalShow from "./components/rental/rental.view";
import NotFound from "./components/notFound";
import { AppBar } from "./components/appBar";
import UpdateYields from "./components/yield-details/update-yields";
// import UpdateResellPrice from './components/resell-price/update-resell-price';
import AmenitiesManagement from "./components/amenities/amenities";
import Analytics from "./components/analytics/Analytics";
import Transactions from "./components/transactions/transactions";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  const handleLogin = () => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col min-h-screen bg-background text-foreground transition-colors duration-200">
        <Toaster />
        <div className="fixed top-0 left-0 right-0 z-50">
          <AppBar />
        </div>
        <div className="flex pt-16">
          <aside className="hidden fixed top-16 bottom-0 w-40 lg:w-60  border-r border-border bg-sidebar bg-background lg:block z-20">
            <Sidebar />
          </aside>
          <main className="flex-1 p-4 ml-40 lg:ml-60 z-10">
            <Routes>
              <Route path="/" element={<Navigate to="/analytics" replace />} />
              <Route path="/users" element={<UserList />} />
              <Route path="/users/:id" element={<UserShow />} />
              <Route path="/assets" element={<AssetList />} />
              <Route path="/assets/:id" element={<NFTShow />} />
              <Route path="/amenities" element={<AmenitiesManagement />} />
              <Route path="/assets/create" element={<NFTCreate />} />
              <Route path="/assets/:id/edit" element={<NFTEdit />} />
              <Route path="/update-yields" element={<UpdateYields />} />
              {/* <Route path='/update-resell-price' element={<UpdateResellPrice />} /> */}
              <Route path="/rental" element={<RentalList />} />
              <Route path="/rental/:id" element={<RentalShow />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
      </div>
    </QueryClientProvider>
  );
};

export default App;
